import network from "@/api/network";

export default class User {
  static async login(data) {
    return await network.post("login", data, {});
  }

  static async register(data) {
    return await network.post("register", data, {});
  }

  static async logout() {
    return await network.post("user/logout/device", null, {});
  }

  static async recoverPassword(data) {
    return await network.post("restore/password/send/link", data, {});
  }

  static async changePassword(data) {
    return await network.post("restore/password", data, {});
  }

  static async acceptAgreement() {
    return await network.post("user/accept/agreement", null, {});
  }

  static async activatePhone(data) {
    return await network.post("confirm/phone", data, {});
  }

  static async requestSmsCode() {
    return await network.get("user/sms", null, {});
  }

  static async unsubscribeFromMailList(params) {
    return await network.get('mailings/unsubscribe', params, {});
  }

  static async getUserProfileGeneral() {
    return await network.get("user/profile/current/info", null, {});
  }
  static async getUserProfileBalance() {
    return await network.get("user/profile/current/points", null, {});
  }
  static async getUserProfileDeals() {
    return await network.get("user/profile/current/approved/deals", null, {});
  }
  static async getUserProfileLimitCurators() {
    return await network.get("user/profile/current/limit/curators", null, {});
  }
  static async getUserProfileLimitCompanies() {
    return await network.get("user/profile/current/limit/companies", null, {});
  }
  static async getUserProfileCurrentCompanies(page, perPage) {
    return await network.get(`user/profile/current/companies?page=${page}&per_page=${perPage}`, null, {});
  }
  static async getUserProfileRelations() {
    return await network.get("user/profile/current/relations", null, {});
  }

}
